import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/footer"
import Header from "../components/header"
import Loader from "../components/loader"
import Logout from "../components/Logout";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Container, Row, Col, Form, Button,Table, Modal, Alert, ProgressBar,Toast } from "react-bootstrap";
import { TableHeader, Pagination } from "../components/DataTable";
import {busquedaCurp, obtenerStatus, obtenerTransacciones, obtenerTransaccionesPaginado, obtenerImagenConsulta} from "../services/api"


const Tabla = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [curp, setCurp] = useState("");

    const [showToast, setShowToast] = useState(false);

    const [show, setShow] = useState(false);
    const [tituloModal, setTituloModal] = useState("");
    const [respuestaModal, setRespuestaModal] = useState("");
    const handleClose = () => setShow(false);

    const [datos, setDatos] = useState([])
    const [sorting, setSorting] = useState({ field: "", order: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const ITEMS_PER_PAGE = 10;
    const headers = [
        { name: "Folio", field: "id", sortable: false },
        { name: "CURP", field: "curp", sortable: false },
        { name: "Fecha de registro", field: "fecha", sortable: false },
        { name: "Hora de registro", field: "hora", sortable: false },
        { name: "Blockchain Hash", field: "blockchain", sortable: false },
        { name: "Veredicto", field: "veredicto", sortable: false },
        { name: "Acciones", field: "action", sortable: false }
    ];

    const [datosConsenso, setDatosConsenso] = useState([])

    const [isModalImagen, setIsModalImagen] = useState(false);
    const handleCloseMI = () => {
        setIsModalImagen(false);
        console.log("cerrando");
        listaPaginado(currentPage)
        /*
        if (!startDate) {
            setCurp(new URL(window.location).searchParams.get("curp"))
            mostrarLista()
        } else {
            filtroRegistro()
        }
        */
    }
    
    const [imagenC, setImagenC] = useState("")

    const [curp2, setCurp2] = useState("");
    const [showP, setShowP] = useState(false);
    const [alerta, setAlerta] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [showAlertP, setShowAlertP] = useState(false)
    const handleClosePM = () => {setShowP(false); setShowAlertP(false)};
    const [msjAlerta, setMsjAlerta] = useState("")

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    useEffect(() => {
        if(localStorage.getItem('colorNodo'))
            document.querySelector(':root').style.setProperty('--principal-color', localStorage.getItem('colorNodo')); 
    }, []);
    useEffect(() => {
        setLoading(true)
        if (new URL(window.location).searchParams.get("curp")) {
            setCurp(new URL(window.location).searchParams.get("curp"))
            mostrarLista()
        } else {
            listaTransaction()
        }
    }, [])

    const mostrarLista = () => {
        let curp = new URL(window.location).searchParams.get("curp")
        setDatos([])
        busquedaCurp(curp,currentPage).then((response) => {
            console.log("responseT",response.data.transactions);
            if( Object.keys(response.data.transactions[0]).length  > 0) {
                setTotalItems(response.data.total_records)
                setDatos(response.data.transactions)
            }else{
                console.log("no hay transactions");
            }
        }).catch((e) => {
            console.log("e",e);
            setTituloModal("Error")
            if(e.response.data.error.description){
                setRespuestaModal(e.response.data.error.description)
            }else{
                setRespuestaModal("Revisa tu conexión a internet")
            }
        }).finally(() => {
            //console.log("finished");
            setLoading(false)
            //setShow(true)
        })
    }

    const listaTransaction = () =>{
        setLoading(true)
        obtenerTransacciones(ITEMS_PER_PAGE,0,0).then((response) => {
            console.log("response:",response.data);
            setTotalItems(response.data.total_records)
            setDatos(response.data.transactions)
        }).catch((e) => {
            console.log("e",e);
            /*
            if(e.response.data.error.description){
                setMsjAlerta(e.response.data.error.description)
            }else{
                setMsjAlerta("Ha ocurrido un error, por favor revisa tu conexión a internet")
            }
            */
            setMsjAlerta("Ha ocurrido un error, por favor revisa tu conexión a internet")
        }).finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
        if(datos.length > 0){
            console.log("hay datos en datos");
            for (let index = 0; index < datos.length; index++) {
                if(datos[index].status_transaction === "PROCESSING"){
                    setTimeout(() => {
                        mostrarLista()
                    }, 3500);
                }
            }
        }
        //setDatos(datos)
    }, [datos])

    useEffect(() => {
        console.log("curp",curp);
    }, [curp])

    const filtroRegistro = () =>{
        setLoading(true)
        setShowAlert(false)
        if(curpValida(curp) || (startDate && endDate)){
            if(startDate && endDate){
                console.log("startDate",startDate);
                console.log("endDate",endDate);
                if(endDate >= startDate){
                    obtenerTransacciones(ITEMS_PER_PAGE, startDate, endDate, curp.toUpperCase()).then((response) => {
                        console.log("response:",response.data.transactions);
                        if(JSON.stringify(response.data.transactions[0]) !== '{}'){
                            setTotalItems(response.data.total_records)
                            setDatos(response.data.transactions)
                        }else{
                            setDatos([])
                        } 
                    }).catch((e) => {
                        console.log("e",e);
                        setShowAlert(true)
                        setAlerta("danger")
                        if(e.response.data.error.description){
                            setMsjAlerta(e.response.data.error.description)
                        }else{
                            setMsjAlerta("Ha ocurrido un error, por favor revisa tu conexión a internet")
                        }
                    }).finally(() => {
                        setLoading(false)
                    })
                }else{
                    setLoading(false)
                    setShowAlert(true)
                    setAlerta("danger")
                    setMsjAlerta("Debes elegir un rango correcto de fechas")
                }

            } else if(!startDate && !endDate){
                console.log("no hay fechas pero si curp",curp);
                obtenerTransacciones(ITEMS_PER_PAGE, 0, 0, curp.toUpperCase()).then((response) => {
                    console.log("response:",response.data.transactions);
                    if(JSON.stringify(response.data.transactions[0]) !== '{}'){
                        setTotalItems(response.data.total_records)
                        setDatos(response.data.transactions)
                    }else{
                        setDatos([])
                    } 
                }).catch((e) => {
                    console.log("e",e);
                    setShowAlert(true)
                    setAlerta("danger")
                    if(e.response.data.error.description){
                        setMsjAlerta(e.response.data.error.description)
                    }else{
                        setMsjAlerta("Ha ocurrido un error, por favor revisa tu conexión a internet")
                    }
                }).finally(() => {
                    setLoading(false)
                })
            }else{
                console.log("fecha error");
                setLoading(false)
                setShowAlert(true)
                setAlerta("danger")
                setMsjAlerta("Por favor de colocar un rango de fechas")
            }
        }else{
            console.log("curp error");
            setLoading(false)
            setShowAlert(true)
            setAlerta("danger")
            setMsjAlerta("Formato de curp no válido y/o fechas incompletas")
        }
        
    }

    const curpValida = (curpInput) => {
        let curp = curpInput.toUpperCase()
        let re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
            validado = curp.match(re);
        
        if (!validado)  //Coincide con el formato general?
            return false;
        
        //Validar que coincida el dígito verificador
        /*
        function digitoVerificador(curp17) {
            //Fuente https://consultas.curp.gob.mx/CurpSP/
            let diccionario  = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
                lngSuma      = 0.0,
                lngDigito    = 0.0;
            for(let i=0; i<17; i++)
                lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
            lngDigito = 10 - lngSuma % 10;
            if (lngDigito == 10) return 0;
            return lngDigito;
        }

        if (validado[2] != digitoVerificador(validado[1])) 
            return false;
        */
        return true; //Validado
    }

    const verConsenso = (trx, filename) => {
        setLoading(true)
        console.log("filename",filename);

        let promiseData = obtenerStatus(trx,0);
        let promise0 = obtenerImagenConsulta(trx, filename,0);
        Promise.allSettled([promiseData, promise0]).then(response => {
            console.log("response",response);
            console.log("data",Object.keys(response[0].value.data).length);

            setDatosConsenso(response[0].value.data)
            console.log("setDatosConsenso",response[0].value.data);

            let lista = [];
            if(response[1].status === "rejected"){
                setImagenC("data:image/png;base64,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")
            }else{
                setImagenC("data:"+response[1].value.data.mime_type+";base64,"+response[1].value.data.image_base64)
            }
            setTimeout(() => {
                setIsModalImagen(true)
                setLoading(false)
            }, 500);

        }, reason => {
            console.log("reason",reason)
            setLoading(false)

        });
    }

    const getFechaHora = (date_created) => {
        if(date_created){
            const f = new Date(date_created);
            let fecha = f.getHours() + ":"+ f.getMinutes()+ ":" +f.getSeconds();
            return fecha;
        }else{
            return "--"
        }
    }

    const getFechaDias = (date_created) => {
        const f = new Date(date_created);
        let mes = f.getMonth() + 1
        if(date_created){
            let fecha = f.getDate() + "."+ mes+ "." +f.getFullYear()
            return fecha;
        }else{
            return "--"
        }
    }

    const getFecha = (date_created) => {
        const f = new Date(date_created);
        let mes = f.getMonth() + 1
        let fecha = f.getDate() + "."+ mes + "." +f.getFullYear()+" | "+f.getHours() + ":"+ f.getMinutes()+ ":" +f.getSeconds();
        return fecha;
    }

    const getTiempo = (d1, d2) => {
        let uno = new Date(d1);
        let dos = new Date(d2);
        let tiempo = dos.getTime()-uno.getTime();
        //console.log("tiempo:",tiempo);
        if(isNaN(tiempo)) 
            return "--"
        else
            return ((tiempo/1000) + 4).toFixed(4) ;
    }

    const buscar = (event) => {
        if(event) event.preventDefault();
        if(curp2){
            if(curp2.length > 9){
                setTimeout(() => {
                    navigate('/datos?curp='+curp2)
                    handleClosePM()
                    window.location.reload()
                }, 300);
            }else{
                console.log("no hay curp");
                setShowAlertP(true)
                setAlerta("danger")
                setMsjAlerta("El curp no cumple con el número de caracteres")
            }
            
        }else{
            console.log("no hay curp");
            setShowAlertP(true)
            setAlerta("danger")
            setMsjAlerta("Por favor revisa que los datos esten completos")
        }
    }

    const copiar = (value) => {
        navigator.clipboard.writeText(value)
        setShowToast(true)
    }

    const abrirBlockChain = (hash) =>{
        //const hostNodes = ["","http://node1.devdicio.net:8080", "http://nodeaws.devdicio.net:8080","http://nodegcp.devdicio.net:8080"]
        const hostNodes = ["",process.env.REACT_APP_NODEBC1, process.env.REACT_APP_NODEBC2,process.env.REACT_APP_NODEBC3]
        let url = hostNodes[localStorage.getItem('nodo')] + "/tx/"+hash
        window.open(url, '_blank').focus();
    } 

    const obtenerDatoOrden = (indice, json) =>{
        //console.log("index",(indice+1));
        let newArray = {};
        if(json){
            //datos.sort(((a, b) => a.id_node - b.id_node));
            let datos = (json.matchnode).sort(function (a, b) {
                var x = a["id_node"],
                y = b["id_node"];    
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
            for (let index = 0; index < datos.length; index++) {
                //console.log("buscando en nodo", index);
                const element = datos[index];
                if(element.id_node === "node_blockchain_"+(indice+1)){
                    //console.log("element.id_node",element.id_node);
                    newArray.exists = element.exists;
                    newArray.liveness = element.liveness;
                    newArray.match = element.match;
                    break;
                }
            }
            //console.log("newArray",newArray.exists);
            if(newArray.exists === 0 || newArray.exists === 1){
                return(
                    <tbody>
                        <tr key="curp">
                            <th>Curp:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                            <th>{newArray.exists === 1 ? <span className="badge rounded-pill bg-success"> <i className="bi bi-check-lg"></i></span> : <span className="badge rounded-pill bg-danger"> <i className="bi bi-x-lg"></i></span>}</th>
                        </tr>
                        {
                            (newArray.exists === 1) ? 
                            <tr key="match">
                                <th>Match:</th>
                                <th>{newArray.match === 1 ? <span className="badge rounded-pill bg-success"> <i className="bi bi-check-lg"></i></span> : <span className="badge rounded-pill bg-warning"> <i className="bi bi-exclamation-lg"></i></span>}</th>
                            </tr>
                            : ""
                        }
                        {
                            (newArray.exists === 1) ? 
                            <tr key="liveness">
                                <th>Liveness:</th>
                                <th>{newArray.liveness === 1 ? <span className="badge rounded-pill bg-success"> <i className="bi bi-check-lg"></i></span> : <span className="badge rounded-pill bg-warning"> <i className="bi bi-exclamation-lg"></i></span>}</th>
                            </tr>
                            : ""
                        }
                    </tbody>
                )
            }else{
                return (                                                                       
                    <p>
                        <b>Estatus:</b> No se realizo consulta<br/>
                    </p>              
                )
            }
        }else{
            console.log("error");
        }
    }

    const listaPaginado = (page) =>{
        setLoading(true)
        obtenerTransaccionesPaginado (ITEMS_PER_PAGE, startDate, endDate, curp, page).then((response) => {
            console.log("response:",response.data);
            setTotalItems(response.data.total_records)
            setDatos(response.data.transactions)
        }).catch((e) => {
            console.log("e",e);
            setMsjAlerta("Ha ocurrido un error, por favor revisa tu conexión a internet")
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleKeyUp = (event) => event.target.value = event.target.value.toUpperCase();

    return (
        <div className="">
            <Logout></Logout>
            {(loading) ? <Loader /> : ("")}
            <Container className="py-4">
                <Header></Header>
                <Row>
                    <Col md={8}>
                        <h5>Resultados de la búsqueda</h5>
                    </Col>
                    <Col md={4}>
                        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
                            <Toast.Body>Información copiada a tu portapapeles.</Toast.Body>
                        </Toast>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Button variant="secondary" data-bs-toggle="modal" onClick={e => setTimeout(() => {
                                navigate('/home')
                            }, 300)}>
                            <i className="bi bi-chevron-left"></i>
                        </Button>
                        &nbsp;
                        <Button variant="secondary" data-bs-toggle="modal" onClick={e => window.location.reload()}>
                            <i className="bi bi-arrow-clockwise"></i> 
                        </Button>
                        &nbsp;
                        <Button variant="primary" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                            Nueva búsqueda 
                        </Button>
                    </Col>
                    <Col md={12} style={{ marginTop: "1%"}}>
                        <Alert key={alerta} variant={alerta} hidden={!showAlert} >
                                {msjAlerta}
                        </Alert>
                        <div className={"collapse"} id="collapseExample">
                            <div className="card card-body">
                                <div className="row justify-content-start">
                                    <div className="col-3">
                                        <p>Selecciona la fecha:</p>
                                        <div className="input-group mb-3" style={{flexWrap: "inherit"}}>
                                            <DatePicker 
                                                selected={startDate} 
                                                onChange={(date) => setStartDate(date)} 
                                                dateFormat="dd/MM/yyyy"
                                                isClearable
                                                placeholderText="Desde: dd/mm/aaaa"
                                                customInput={<input id="fechaini" type="text" className="form-control" placeholder="Desde: dd/mm/aaaa" aria-label="Recipient's username" aria-describedby="basic-addon2" />}
                                            />
                                            <span className="input-group-text" id="basic-addon2"><i className="bi bi-calendar3"></i></span>
                                        </div>
                                    </div>
                                    
                                    <div className="col-3">
                                        <p style={{color: "white"}}>.</p>
                                        <div className="input-group mb-3"  style={{flexWrap: "inherit"}}>
                                            <DatePicker 
                                                    selected={endDate} 
                                                    onChange={(date) => setEndDate(date)} 
                                                    dateFormat="dd/MM/yyyy"
                                                    isClearable
                                                    placeholderText="Hasta: dd/mm/aaaa"
                                                    customInput={<input id="fechaini" type="text" className="form-control" placeholder="Hasta: dd/mm/aaaa" aria-label="Recipient's username" aria-describedby="basic-addon2" />}
                                            />
                                            <span className="input-group-text" id="basic-addon2"><i className="bi bi-calendar3"></i></span>
                                        </div>
                                    </div>

                                    <div className="col-3">
                                        <p>Ingresa el CURP:</p>
                                        <div className="col-auto">
                                            <input id="curpF" type="text" className="form-control" placeholder="Ej: SOAL821123G64" value={curp} onChange={event => setCurp(event.target.value)} onKeyUp={handleKeyUp}/>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <p style={{color: "white"}}>.</p>
                                        <button type="button" className="btn btn-primary mb-3" disabled={!(curp || (startDate && endDate))} onClick={() => {filtroRegistro()}} >Filtrar registros</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <div className="table-responsive">
                    <Table>
                    <TableHeader
                    headers={headers}
                    onSorting={(field, order) =>
                        setSorting({ field, order })
                    }
                    />
                    <tbody>
                        {
                            (datos.length > 0) ? 
                                datos.map((item, index) => (
                                    <tr key={"ID"+index}>
                                        {
                                            (item.transaction_code !== null) ? 
                                                //<td><button type="button" className="btn btn-outline-secondary btn-sm" onClick={(e) => {copiar(item.transaction_code)}}><i className="bi bi-front"></i></button>&nbsp;&nbsp;<b>{(item.transaction_code).split("-")[0]}</b></td>
                                                <td><b>{(item.transaction_code).split("-")[0]}</b></td>
                                                :
                                                <td><i className="bi bi-clock-history"></i></td>
                                        }
                                        <td><b>{item.curp}</b></td>
                                        <td>{getFechaDias(item.date_created)}</td>
                                        <td>{getFechaHora(item.date_created)}</td>
                                        {
                                            (item.hash_blockchain !== null) ? 
                                                (item.status_transaction !== "ERROR" || item.status_transaction !== "INCOMPLETED") ?
                                                    <td><button type="button" className="btn btn-outline-secondary btn-sm" onClick={(e) => {abrirBlockChain(item.hash_blockchain)}}><i className="bi bi-box-arrow-up-right"></i></button>&nbsp;&nbsp;{(item.hash_blockchain).substr(0,4)}...{(item.hash_blockchain).substr(item.hash_blockchain.length - 5)}</td>
                                                    :
                                                    <td><span className="badge rounded-pill bg-secondary"> <i className="bi bi-three-dots"></i></span></td>
                                                :
                                                (item.status_transaction !== "ERROR" && item.status_transaction !== "INCOMPLETED") ?
                                                    <td><i className="bi bi-clock-history"></i></td>
                                                    :
                                                    <td><span className="badge rounded-pill bg-secondary"> <i className="bi bi-three-dots"></i></span></td>
                                        }
                                        <td className="">
                                            {
                                            (item.result_text === "green") ? 
                                                <span className="badge rounded-pill bg-success"> <i className="bi bi-check-lg"></i></span> 
                                                : 
                                                    (item.result_text === "yellow") ? 
                                                        <span className="badge rounded-pill bg-warning"> <i className="bi bi-exclamation-lg"></i></span>  
                                                        : 
                                                        (item.result_text === "red") ? 
                                                            <span className="badge rounded-pill bg-danger"> <i className="bi bi-x-lg"></i></span> 
                                                            : 
                                                            (item.status_transaction === "INCOMPLETED" || item.status_transaction === "ERROR") ? 
                                                                <span className="badge rounded-pill bg-secondary"> <i className="bi bi-exclamation-lg"></i></span>  
                                                                : 
                                                                <div style={{marginTop:"8px", width:"50%"}}><ProgressBar animated now={100} /></div>
                                            }
                                        </td>
                                        <td>
                                            <button type="button" className="btn btn-primary " 
                                                onClick={e => {
                                                    let btn = document.getElementById(`btn-modal-open${index}`);
                                                    btn.click();
                                                    verConsenso(item.transaction_code, item.image_name, item.id_node);
                                                }}><span className="new badge hoverable">Ver resultados</span>
                                            </button>
                                            <a hidden id={`btn-modal-open${index}`} className="modal-trigger"><span className="new badge hoverable"></span></a>
                                        </td>
                                        
                                    </tr>
                                ))
                                : <p><b>No hay datos</b></p>
                        }
                    </tbody>
                    </Table>
                    <nav aria-label="Page navigation example">
                        <Pagination
                            total={totalItems}
                            itemsPerPage={ITEMS_PER_PAGE}
                            currentPage={currentPage}
                            className="justify-content-center"
                            onPageChange={page => {setCurrentPage(page); listaPaginado(page)}}
                        />
                    </nav>
                    </div>
                
                
                </Row>
                <hr />
                
                <Modal show={isModalImagen} onHide={handleCloseMI} size="lg" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Análisis Biométrico</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <table style={{width:"80%"}}>
                            <tbody>
                                <tr key="table-1">
                                <td><div className="cover_bgx" style={{width:"150px", height:"150px", backgroundImage: `url(${imagenC})`}}></div></td>
                                    { 
                                        (Object.keys(datosConsenso).length > 0) ? 
                                            (Object.keys(datosConsenso.errors[0]).length === 0) ? 
                                                <td>
                                                    <p>
                                                        <b>RENAPO:</b> {(datosConsenso.client.renapo_valid) ? <span className="badge rounded-pill bg-success"> <i className="bi bi-check-lg"></i></span>:   <span className="badge rounded-pill bg-danger"> <i className="bi bi-check-lg"></i></span>}<br/>
                                                        {datosConsenso.client.names + " " + datosConsenso.client.paternal_surname + " " + datosConsenso.client.mothers_maiden_name}<br/>
                                                        {datosConsenso.query.curp}<br/>
                                                        <b>Comparación biométrica:</b><br/> {(datosConsenso.query.status_transaction === "TERMINATED") ? "Terminada": "En proceso" }<br/>
                                                    </p>
                                                </td>
                                                :
                                                <td>
                                                    <p>
                                                        <b>Descripción del error:</b><br/>{datosConsenso.errors[0].description_error} <br/>
                                                        <b>Fecha de consulta:</b> <br/>{getFecha(datosConsenso.errors[0].date_created)}<br/>
                                                    </p>
                                                </td>

                                            :
                                            <td></td>
                                    }
                                    { 
                                        (Object.keys(datosConsenso).length > 0) ? 
                                            (Object.keys(datosConsenso.errors[0]).length === 0) ? 
                                                <td>
                                                    <p>
                                                        <b className="text-white">.</b><br/>
                                                        <b>Fecha de consulta:</b><br/> {getFecha(datosConsenso.query.date_created)}<br/>
                                                        <b>Tiempo de consulta:</b><br/> {getTiempo(datosConsenso.query.date_created, datosConsenso.score.date_created)} seg
                                                    </p>
                                                </td>
                                                :
                                                <td>
                                                    <p>
                                                    </p>
                                                </td>

                                            :
                                            <td></td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                        <table className="table">
                            <thead>
                                <tr key="table-2">
                                    <th scope="col">Nodo</th>
                                    <th scope="col">Resultado</th>
                                </tr>
                            </thead>
                            <tbody>
                                { 
                                    (Object.keys(datosConsenso).length > 0) ? 
                                        datosConsenso.matchnode.map((item, index) => (
                                            <tr key={"subtabla-" + index}> 
                                            <th scope="row" className="nodoImg">
                                                <div>
                                                    <img  src={datosConsenso.matchnode[index].logo_node}></img>
                                                </div>
                                            </th>
                                            <td>
                                                    {
                                                        (datosConsenso.matchnode[index]) ?
                                                            <table>
                                                                {obtenerDatoOrden(index, datosConsenso)}
                                                            </table>
                                                            :
                                                            <p>
                                                                <b>Estatus:</b> No se realizo consulta<br/>
                                                            </p>
                                                    }
                                            </td>
                                            </tr>
                                        ))
                                    : <p>No hay datos</p>
                                }
                            </tbody>
                        </table>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseMI}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{tituloModal}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>{respuestaModal}</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showP} onHide={handleClosePM} size="xl" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Ingresa el CURP para buscar:</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                    <Alert key={alerta} variant={alerta} hidden={!showAlertP} >
                        {msjAlerta}
                    </Alert>
                    <Row>
                        <Col>
                            <h5>Sube una <b>foto</b> y su <b>CURP</b> para validar una identidad:</h5> <br />
                        </Col>
                    </Row>
                    <Row className="justify-content-start">
                        <Col md={4}>
                            <div className="col-auto">
                                <input type="text" className="form-control" id="inputPassword2" placeholder="Ej: SOAL821123G64" onChange={event => setCurp2(event.target.value)}/>
                            </div>
                        </Col>
                        <Col md={4}>
                            <Button type="submit" className="btn btn-primary mb-3" disabled={!(curp2)} onClick={event => buscar(event)}>Buscar proceso</Button>
                        </Col>
                    </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClosePM}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Footer>
                </Footer>
            </Container>

        </div>
    )
}

export default Tabla